import { FunctionComponent } from 'react';
import { FilterState } from './MentorManagement';
import {
  DateButton,
  DateButtonIcon,
  DateButtonText,
  DateFilter,
  DateGroup,
  FilterBar,
  FilterGroup,
} from '../common/AdminFilterPrimitives';
import AdminFilterDropdown from '../common/AdminFilterDropdown';
import AdminSearchInput from '../common/AdminSearchInput';

interface MentorFilterProps {
  filter: FilterState;
  onFilterChange: (filter: Partial<FilterState>) => void;
  onDateModalOpen: () => void;
}

const MentorFilter: FunctionComponent<MentorFilterProps> = ({
  filter,
  onFilterChange,
  onDateModalOpen,
}) => {
  const handleStatusChange = (status: string) => {
    onFilterChange({ status });
  };

  return (
    <FilterBar>
      <FilterGroup>
        <DateFilter>
          <DateGroup>
            <DateButton type="button" onClick={onDateModalOpen}>
              <DateButtonText>
                {filter.fromDate && filter.toDate
                  ? `${filter.fromDate} ~ ${filter.toDate}`
                  : filter.fromDate
                    ? `${filter.fromDate} ~`
                    : '등록일'}
              </DateButtonText>
              <DateButtonIcon width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M4.17 5.25L7 8.08L9.83 5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </DateButtonIcon>
            </DateButton>
          </DateGroup>
        </DateFilter>

        <AdminFilterDropdown
          value={filter.status}
          onChange={handleStatusChange}
          options={[
            { value: 'all', label: '상태' },
            { value: 'temp', label: '임시 저장' },
            { value: 'approved', label: '등록 완료' },
          ]}
        />
      </FilterGroup>

      <AdminSearchInput
        value={filter.searchTerm}
        onChange={(value) => onFilterChange({ searchTerm: value })}
      />
    </FilterBar>
  );
};

export default MentorFilter;
